// create-doc-tool.js
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};

export const handleDownload = (documentInfo) => {
  try {
    // Direct download using anchor tag - no CORS issues
    const a = document.createElement('a');
    a.href = documentInfo.downloadUrl; // S3 URL
    a.download = `${documentInfo.title}.${documentInfo.format}`;
    a.target = '_blank'; // Fallback: open in new tab if download attribute not supported
    a.rel = 'noopener noreferrer'; // Security best practice
    document.body.appendChild(a);
    a.click();

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(a);
    }, 100);
  } catch (error) {
    console.error('Download failed:', error);
    alert(`Download failed: ${error.message}`);
  }
};

export const renderDocumentBlock = (tool, idx) => {
  return (
    <div key={idx} style={{
      marginTop: '0',
      padding: '0',
    }}>
      <div style={{
        marginBottom: '10px',
        padding: '10px',
        backgroundColor: 'var(--sa-dark-surface-light)',
        borderRadius: '4px',
        border: '1px solid var(--sa-dark-border)',
        whiteSpace: 'pre-wrap',
        fontFamily: 'monospace',
        fontSize: '14px'
      }}>
        <h4 style={{ margin: '0 0 8px 0', }}>
          {tool['result'].document.title}
        </h4>
        {tool['args'].content.split('\n').map((line, i) => (
          <div key={i}>{line}</div>
        ))}
        <pre style={{
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
          margin: 0,
          fontSize: '14px',
          lineHeight: '1.4',
          color: 'var(--sa-dark-text)'
        }}>
          {tool['args'].content}
        </pre>
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <span style={{ fontSize: '13px', color: '#666' }}>
          {tool['result'].document.format.toUpperCase()} • {formatFileSize(tool['result'].document.size)}
        </span>
        <button
          onClick={() => handleDownload(tool['result'].document)}
          style={{
            padding: '4px 12px',
            backgroundColor: 'transparent',
            color: 'var(--primary-color)',
            border: '1px solid var(--primary-color)',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15V3M12 15L8 11M12 15L16 11" stroke="var(--primary-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20 17V21H4V17" stroke="var(--primary-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Download
        </button>
      </div>
    </div>
  );
};
